export default __webpack_public_path__ + "static/media/icon-blockchain.28ce8077.svg";